import { useEffect, useState } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Form from 'react-bootstrap/esm/Form';
import Row from 'react-bootstrap/esm/Row';
import Table from 'react-bootstrap/esm/Table';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppDispatch, RootState } from '../../app/store';
import MeasurementInputTypeDisplay from '../inputs/MeasurementInputTypeDisplay';
import ValueTypeDisplay from '../inputs/ValueTypeDisplay';
import LoadingIndicator from '../loading/LoadingIndicator';
import { useAuth } from '../signin/auth';
import { listMeasurements, selectAllMeasurements } from './measurementsSlice';
import { Measurement } from './types';

function ListMeasurements() {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const [hideInactive, setHideInactive] = useState(true);
  const measurements = useSelector(selectAllMeasurements)
  const status = useSelector((state: RootState) => state.measurements.status)
  const error = useSelector((state: RootState) => state.measurements.error)

  const toggleHideInactive = () => {
    setHideInactive(!hideInactive);
  };

  useEffect(() => {
    if (auth.authToken) {
      dispatch(listMeasurements({ authToken: auth.authToken }));
    } else {
      console.log('No auth token!');
    }
  }, [dispatch, auth.authToken])

  const renderMeasurementRow = (m: Measurement) => {
    return (
      <tr key={m.id}>
        <td>
          <Link to={`/measurement/${m.id}`}>{m.name}</Link>
        </td>
        <td>
          <Form.Check checked={m.active} disabled={true} />
        </td>
        <td>
          <ValueTypeDisplay value={m.type} />
        </td>
        <td>
          <MeasurementInputTypeDisplay value={m.inputType} />
        </td>
        <td>
          {m.order}
        </td>
        <td>
          <Link to={`/measurement/${m.id}/edit`}>Edit</Link>
        </td>
      </tr>
    );
  };

  const renderMeasurements = () => {
    let content
    if (measurements.length > 0) {
      const orderedMeasurements = measurements
        .slice()
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .filter(a => (!hideInactive) || a.active);
      content = orderedMeasurements.map((m: Measurement) => renderMeasurementRow(m));
    }
    return content;
  };

  return (
    <div>
      {status === 'loading' && <LoadingIndicator />}
      {status === 'failed' && <div>{error}</div>}
      {measurements.length > 0 && (
        <>
          <Row>
            <Col sm="auto">
              <Form.Check id="filter-to-active" checked={hideInactive} onChange={toggleHideInactive} label="Show active measurements only?" />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Table striped>
                <thead>
                  <tr>
                    <th>Measurement</th>
                    <th>Active</th>
                    <th>Value Type</th>
                    <th>Input Type</th>
                    <th>Order</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {renderMeasurements()}
                </tbody>
              </Table>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
}

export default ListMeasurements;